import React , {Component} from 'react';
import NumberFormat from 'react-number-format';
class FoodCard extends Component{



    constructor(props) {
        super(props);

    }



    render(){

        const {  object , onAddToCartClicked , onRemoveFromCartClicked , selected , count} = this.props
        let price = object.price
        if (object.food_discount > 0)
            price = price - ( price * object.food_discount / 100)
        return(
            <div className={ selected ? "food selected" : "food"}>
                <div className="row no-gutters">
                    <div className="col-70">
                        <div className="details">
                            <div className="title">
                                {object.title_fa}
                                {
                                    object.special_offer === true ? (
                                        <span className="status">
                                            ویژه
                                        </span>
                                    ):(
                                        ``
                                    )
                                }
                                {

                                    object.food_discount > 0 && object.special_offer === false ? (
                                        <span className="status">
                                            {object.food_discount} %
                                        </span>
                                    ) : (``)
                                }


                                {
                                    object.active === false ? (
                                        <span className="description pr-2">
                                            ( موجود نمی باشد )
                                        </span>
                                        ):
                                        (``)
                                }

                            </div>

                            <div className="description">
                                {object.description}
                            </div>

                        </div>
                        <div className="footer"  >

                            <div className="row">
                                <div className="col text-right">
                                    <div className={ this.props.count > 0 ? `stepper order-count` : `stepper` } >
                                        <div className="stepper-button-minus" onClick={onRemoveFromCartClicked}>

                                        </div>
                                        <div className="stepper-input-wrap">
                                            <input type="text" value={this.props.count} readOnly={true} />
                                        </div>
                                        {
                                            object.active === true ? (
                                                <div className="stepper-button-plus" onClick={onAddToCartClicked}>

                                                </div>
                                            ) : (``)
                                        }

                                    </div>
                                </div>
                                <div className="col text-left">
                                    <div className="price">
                                        <NumberFormat value={price} displayType={'text'} thousandSeparator={true}  />
                                          تومان
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-30">
                        <div className="img-container">
                            <img src={object.thumbnail} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default FoodCard;